import moment from "moment";
import React, { useState, useMemo, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useHistory, useParams } from "react-router-dom";
import { DeleteAssessment, GetAssessmentListCancelToken, lockedProgrammes } from "../../../../services/CourseService";
import { IMAGE_URL, TABLE_DATE_FORMAT, TABLE_DATE_TIME_FORMAT, TABLE_ROWS_PER_PAGE, TABLE_TIME_FORMAT } from "../../../../utils/Constants";
import { InitialRender } from "../../../common/Helper";
import { ColorRender } from "../../../systemadministration/usermanagement/CheckRole";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import PermissionsGate from "../../../../utils/permissionGate";
import Hover from "../../../common/Hover";
import { checkIfImageExists, handleIntakeSort, handleTableScroll, sortUtils, handleGradesLocked } from "../../../../utils/commonFunction";
import Tablefilter from "../../../common/Tablefilter";
import { RenderAssessmentStatus, RenderQuizType } from "../../../../utils/CommonStatusItems";
import { RenderAssessmentType, RenderAssessmentTypeNew } from "../../../../utils/CommonGroupingItem";
import Swal from "sweetalert2";
import axios from "axios";
import UserColumn from "../../../common/UserColumn";
import $ from 'jquery';

const AssignedAssessments = (props) => {

  const { tab, id } = useParams();
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [intake, setIntake] = useState({ arr: [], checkObj: {} });
  const [markingStatus, setMarkingStatus] = useState({ arr: [], checkObj: {} });
  const [type, setType] = useState({ arr: [], checkObj: {} });
  const [assessmentType, setAssessmentType] = useState({ arr: [], checkObj: {} });
  const [assessmentList, setAssessmentList] = useState([]);
  const [isListLoaded, setIsListLoaded] = useState(false);
  const [filterData, setFilterData] = useState({ intake: [], type: [], status: [], mStatus: [], assessmentType:[] });
  const [filterCheck, setFilterCheck] = useState("true");
  const [deleteAssessment, setDeleteAssessment] = useState(Date.now());
  const [isShowingAllUser, setIsShowingAllUser] = useState([]);
  const [linkedProgrammes, setLinkedProgrammes] = useState([]);
  const [isGradeLocked, setIsGradeLocked] = useState(true);
  const [update, setUpdate] = useState(false);
  const [isAssessmentBtnLoading, setIsAssessmentBtnLoading] = useState({});
  
  let quizId = props?.quizId;


  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {        
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })

  useEffect(() => {
    handleTableScroll()
  }, [isListLoaded])
  useEffect(() => {
    const cancelTokenSources = [];

    const getAssessmentsList = async () => {
      setIsListLoaded(false);
      props.setLoad(true)

      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });

      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      try {
        let data = filterCheck;
        let res = await GetAssessmentListCancelToken(id, data, quizId, source.token)
        if (res.status === 200) {
          setAssessmentList(res.data && res.data.result.length ? res.data.result : []);
          setIsListLoaded(true);
          props.setLoad(false)

          let typeFilter = res.data.typeFilter.sort((a, b) => b.label.localeCompare(a.label));
          
          if (filterCheck == "true") {
            setFilterData({ ...res.data, intake: res.data.yearsAndIntaksFilter, type: res.data.assessmentTypeFilter, status: res.data.statusFilter, mStatus: res.data.MarkingStatusFilter, assessmentType: typeFilter });
            setFilterCheck("false")
          }
        }

        const result = await getLockedProgrammes([Number(id)])

        if (result?.success) {
          setIsGradeLocked(false);
          setLinkedProgrammes(result);
        }

      } catch (error) {
        setIsListLoaded(true);
        setIsGradeLocked(false);
        console.log("AssignedAssessments:", error);
        props.setLoad(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.message || "Something went wrong",
        });
      }
    }
    getAssessmentsList();

    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [deleteAssessment])

  const dataToRender = () => {
    let updatedData = [];
    let allData = assessmentList;
    if (search.length) {
      let tempStudent = allData.filter((item) => {
        let includes = item.name && item.name.toString().toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempCode = allData.filter((item) => {
        let includes = item?.code?.toString().toLowerCase().includes(search.toString().toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let data = [
        ...tempStudent,
        ...tempCode
      ];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (status.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = status.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.status.toString().toLowerCase() ? item.status.toString().toLowerCase() : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (type.arr.length) {
      let tempType = updatedData;
      let tempResult = tempType.filter((item) => {
        const startsWith = type?.arr?.find(function (post, index) {
          if (post?.toString()?.toLowerCase() === item?.type?.toString()?.toLowerCase()) {
            return item;
          }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (markingStatus.arr.length) {
      let tempStatus = updatedData;
      let tempMarkingStatus = tempStatus.filter((item) => {
        const startsMarking = markingStatus.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.markingStatus.toString().toLowerCase() ? item.markingStatus.toString().toLowerCase() : "") return item;
        });
        if (startsMarking) {
          return startsMarking;
        } else return null;
      });

      updatedData = tempMarkingStatus;
    }
    if (intake.arr.length) {
      let tempStatus = updatedData;
      let tempIntakeHash = tempStatus.filter((item) => {
        const startsMarking = intake.arr.find(function (post, index) {
          if (post == (item.number && item.year ? item.year + "/" + item.number : "")) return item;
        });
        if (startsMarking) {
          return startsMarking;
        } else return null;
      });

      updatedData = tempIntakeHash;
    }
    if (assessmentType.arr.length) {
      let tempStatus = updatedData;
      let tempAssType = tempStatus.filter((item) => {
        const startsWith = assessmentType.arr.find(function (post, index) {
          if (post.toString().toLowerCase() === item.assignment_type.toString().toLowerCase()) {
            return item;
          }
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempAssType;
    }

    return updatedData;
  };

  const getSubmissionSortValue = (val) => {
    if (!val || val === "-") return -1;
  
    const [done, total] = String(val).split("/").map(Number);
  
    if (isNaN(done) || isNaN(total)) return -1;
  
    // important: preserve order priority
    // done has higher priority than total
    return done * 100000 + total;
  };
  

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      sortFunction: sortUtils.stringSort("name"),
      cell: (row) => {
        return (
          <span
            title={row.name}
            className="overflow-ellipsis2 ">
            {row.name ?
              row.disable_assessment=="1" ? 
              <span className="feature-name">
                <span className="textLimit100">{row.name}</span>
              </span>
              : quizId ? (
                // For assessment list in quiz section, work here

                <PermissionsGate scopes={["castview"]} RenderError={() => <span className="textLimit100">{row.name}</span>}>
                  <Link className="as-text-blue curser feature-name"
                  to={quizId ? `/courseAdministration/coursesdetails/${row.intake}/assessments/open/assigned/Details/${row.id}` : row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
                >
                  <span className="textLimit100">{row.name}</span>
                </Link>
              </PermissionsGate>
              ):
              // For assessment list in any other section, work here

              <Link className="as-text-blue curser feature-name"
                  to={row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`}
                >
                  <span className="textLimit100">{row.name}</span>
                </Link>
              : "-"}
          </span>
        )
      }
    },
    {
      name: "Status",
      selector: row => row.status ? RenderAssessmentStatus(row.status).text : "",
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const a = (RenderAssessmentStatus(rowA.status).text || "").toLowerCase();
        const b = (RenderAssessmentStatus(rowB.status).text || "").toLowerCase();
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
      },
      cell: (row) => row.status ? RenderAssessmentStatus(row.status).html : "-",
    },
    {
      name: "Type",
      selector: "type",
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const a = (RenderAssessmentTypeNew(rowA.type,rowA?.assignment_type).text || "").toLowerCase();
        const b = (RenderAssessmentTypeNew(rowB.type,rowB?.assignment_type).text || "").toLowerCase();
        return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
      },
      cell: (row) => (
        row.type ? RenderAssessmentTypeNew(row.type,row?.assignment_type).html : "-"
      )
    },
    {
      name: "Code",
      selector: "code",
      sortable: true,
      sortFunction: sortUtils.stringSort("code"),
      cell: (row) => (
        <p>{row.code && row.code != '' ? row.code : '-'}</p>
      )
    },
    {
      name: "Intake",
      selector: row => row.year && row.number ? `${row.year} - ${row.number}` : "",
      sortable: true,
      sortFunction: handleIntakeSort,
      cell: (row) => (
        <p>{row.year && row.number ? `${row.year} - ${row.number}` : "-"}</p>
      )
    },
    {
      name: "Open Date",
      selector: "open_date_time",
      sortable: true,
      cell: (row) => (
        row.open_date_time ?
          <>
            <p className="right-space">{moment.unix(row.open_date_time).format(TABLE_DATE_FORMAT)}</p>
            <p>{moment.unix(row.open_date_time).format(TABLE_TIME_FORMAT)}</p>
          </>
          : "-"
      )
    },
    {
      name: "Due Date",
      selector: "close_date_time_mili",
      sortable: true,
      cell: (row) => (
        row.close_date_time_mili ?
          <>
            <p className="right-space">{moment.unix(row.close_date_time_mili).format(TABLE_DATE_FORMAT)}</p>
            <p>{moment.unix(row.close_date_time_mili).format(TABLE_TIME_FORMAT)}</p>
          </>
          : "-"
      )
    },
    {
      name: <><i className="fal fa-file-check mr-1"></i>Status </>,
      selector: "markingStatus",
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const a =
          rowA.markingStatus &&
          rowA.newMarkDate_mili &&
          rowA.newMarkDate_mili != "NaN"
            ? RenderAssessmentStatus(rowA.markingStatus).text.toLowerCase()
            : "";
    
        const b =
          rowB.markingStatus &&
          rowB.newMarkDate_mili &&
          rowB.newMarkDate_mili != "NaN"
            ? RenderAssessmentStatus(rowB.markingStatus).text.toLowerCase()
            : "";
    
        return a.localeCompare(b, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      },
      cell: (row) => (
        (row.markingStatus && row.newMarkDate_mili && row.newMarkDate_mili != "NaN") ? RenderAssessmentStatus(row.markingStatus).html : "-"
      ),
    },
    {
      name : 'Marking Details',
      cell: (row) => (
        <>
            <div className="d-flex gap-3 justify-content-between pr-5">
              {/* Marker section */}
              <div className="d-flex">
                <div className="d-flex flex-column me-2">
                  <small className="text-muted-assessment"><i className="fal fa-user"></i> Marker</small>
                  <div className="d-flex align-items-center">
                    <UserColumn
                      multipleUserStacks
                      isShowingAllUser={isShowingAllUser}
                      setIsShowingAllUser={setIsShowingAllUser}
                      usersArray={row.markerList}
                      rowId={row.id}
                      usersArrayData={{
                        firstName: "Firstname",
                        lastName: "Lastname",
                        imgUrl: "picture_me",
                        email: "Email",
                        mobile: "Mobile",
                        userId: "UserID",
                        userActiveStatus: "Status",
                        right: true
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Moderator section */}
              <div style={{ width: 155 }}>
                <div className="d-flex flex-column me-2">
                  <small className="text-muted-assessment"><i className="fal fa-user-clock"></i> Moderator</small>
                  <div className={`d-flex align-items-center ${!row.moderatorName && 'mt-2'}`}>
                    {row.moderatorName ? (
                      <>
                        <div className="assigned-title-block-new">
                          <div className="assigned-title-itm mt-2">
                            <span className={"assigned-title-blk  name-icon cat-dark-red " + ColorRender(row.role_name)}>
                              {row.moderatorProfile && checkIfImageExists(`${IMAGE_URL}/${row.moderatorProfile.replaceAll("/home/myaie/public_html/", "")}`) ? <img src={`${IMAGE_URL}/${row.moderatorProfile.replaceAll("/home/myaie/public_html/", "")}`} alt="AIE" /> : InitialRender([row.moderatorName.split(" ")[0], row.moderatorName.split(" ")[1]])}
                              <span className={`profile-box-2-status ${row.moderator_activity_status ? row.moderator_activity_status.toLowerCase() == "online" ? "Online" : row.moderator_activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                                <i className="fas fa-circle"></i>
                              </span>
                              <Hover firstName={row.moderatorName.split(" ")[0]} lastName={row.moderatorName.split(" ")[1]} photo={row.moderatorProfile} email={row.moderatorEmail} mobile={row.moderatorContact} status={row.moderator_status} activity_status={row.moderator_activity_status} right={false} role={"marker"} />
                            </span>
                            <Link className="as-text-blue curser" title={row.moderatorName} to={`/systemAdministration/userManagement/open/${row.moderator_id}/aboutYou`}>
                              <span className="textLimit100">{row.moderatorName}</span>
                            </Link>
                          </div>
                        </div>
                      </>
                    ) : "-"}
                  </div>
                </div>
              </div>

              {/* Due date */}
              <div className="d-flex flex-column">
                <small className="text-muted-assessment"><i className="fal fa-calendar-day"></i> Due</small>
                {row.newMarkDate_mili && row.newMarkDate_mili != "NaN" && parseInt(row.newMarkDate_mili) ?
                  <div className="mt-1">
                    <p className="right-space">{moment.unix(parseInt(row.newMarkDate_mili)).format(TABLE_DATE_FORMAT)}</p>
                    <p>{moment.unix(parseInt(row.newMarkDate_mili)).format(TABLE_TIME_FORMAT)}</p>
                  </div>
                  : "-"}
              </div>

              {/* Overdue */}
              <div className="d-flex flex-column">
                <small className="text-muted-assessment"><i className="fal fa-exclamation-triangle"></i> Overdue</small>
                <p className="mt-1">{row.markingStatus == "Marked" ? "N/A" : row.markingOverDueDays ? row.markingOverDueDays : "-"}</p>
              </div>
            </div>
        </>
      )

    },
    {
      name: <i className="fal fa-user-check" title="Submissions"></i>,
      cell: (row) => (
        <p>{row.submission ? row.submission : "-"}</p>
      )
    },
    {
      name: "Actions",
      cell: (row) => (
        row.type=="Supplementary Exam" ? 
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">
              <button className="btn btn-primary rounded-circle mr-1" title="Open" disabled={row.disable_assessment=="1"} onClick={()=>{history.push(quizId ? `/courseAdministration/coursesdetails/${row.intake}/assessments/open/assigned/Details/${row.id}` : row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`)}}>
                <i className="fal fa-folder-open"></i>
              </button>
            {!quizId &&
            <PermissionsGate scopes={["castdelete"]} errorProps={{ disabled: true }}>
              <button className="btn btn-danger rounded-circle" title="Delete" disabled={isAssessmentBtnLoading[row.id]} onClick={() => handleDelete(row.id)}>
                {isAssessmentBtnLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-trash-alt"></i>}
              </button>
            </PermissionsGate>            
            }
          </div>
        </div>
        :
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons">

          {quizId ? 
             <PermissionsGate scopes={["castview"]} errorProps={{ disabled: true }}>              
            <button className="btn btn-primary rounded-circle mr-1" title="Open" disabled={row.disable_assessment=="1"} onClick={()=>{history.push(`/courseAdministration/coursesdetails/${row.intake}/assessments/open/assigned/Details/${row.id}`)}}>
            <i className="fal fa-folder-open"></i>
            </button>            
            </PermissionsGate>
            : 
            <>
            <button className="btn btn-primary rounded-circle mr-1" title="Open" disabled={row.disable_assessment=="1"} onClick={()=>{history.push(row.Assmenttype == "no" ? `/courseAdministration/coursesdetails/${id}/${tab}/open/assigned/Details/${row.id}` : `/courseAdministration/assessment/quizzes/open/details/${row.smart_assignment_id}`)}}>
            <i className="fal fa-folder-open"></i>
            </button> 
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" title="More" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {/* <PermissionsGate scopes={["castadd"]} errorProps={{ disabled: true }}> */}
                  <button className="btn btn-primary rounded-circle" title="Duplicate" disabled={isAssessmentBtnLoading[row.id]} onClick={() => handleDuplicateAssessment(row.id)}>
                    {isAssessmentBtnLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-copy"></i>} 
                  </button>
                {/* </PermissionsGate> */}
                <PermissionsGate scopes={["castdelete"]} errorProps={{ disabled: true }}>
                  <button className="btn btn-danger rounded-circle" title="Delete" disabled={isAssessmentBtnLoading[row.id]} onClick={() => handleDelete(row.id)}>
                    {isAssessmentBtnLoading[row.id] ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-trash-alt"></i> }
                  </button>
                </PermissionsGate>
              </div>
            </div>
            </>
          }
          </div>
        </div>
      ),
    },
  ], [isShowingAllUser, isGradeLocked, linkedProgrammes, isAssessmentBtnLoading]);

  const handleDelete = async(ID) => {
    const result = await getLockedProgrammes([], ID);
    if (result && result?.isLocked) {
      handleGradesLocked(result.data, "assessment");
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteAssessment({ assessment_id: ID }).then((res) =>
          setDeleteAssessment(Date.now())
        );
        Swal.fire("Deleted!", "Your assessment has been deleted.", "success");
      }
    });
  };

  const exportData = (fileType, fileName) => {
    let data = dataToRender();
    const header = ["Name", "Status", "Type", "Assessment Code", "Intake", "Open Date", "Due Date", "Marking Status", "Marker", "Moderator", "Marking Due Date", "Marking Over Due Days", "Submissions"];
    data = data?.map((row) => ({
      ...row,
      Name: row?.name ? row.name : "-",
      Status: row?.status ? row?.status.toUpperCase() : "-",
      Type: row.type ? `${row?.assignment_type}-${row.type}` : "-",
      "Assessment Code": row?.code ? row.code : "-",
      Intake: row.year && row.number ? row.year + "-" + row.number : "-",
      "Open Date": row.open_date_time ? moment.unix(row.open_date_time).format(TABLE_DATE_TIME_FORMAT) : "-",
      "Due Date": row.due ? moment.unix(row.due).format(TABLE_DATE_TIME_FORMAT) : "-",
      "Marking Status": (row?.markingStatus && row.newMarkDate_mili && row.newMarkDate_mili != "NaN") ? row?.markingStatus : "-",
      Marker: row?.markerName ? row?.markerName : "-",
      Moderator: row?.moderatorName ? row.moderatorName : "-",
      "Marking Due Date": (row?.newMarkDate_mili && row.newMarkDate_mili != "NaN") ? moment.unix(row.newMarkDate_mili).format(TABLE_DATE_TIME_FORMAT) : "-",
      "Marking Over Due Days": row.markingStatus == "Marked" ? "N/A" : row?.markingOverDueDays ? row?.markingOverDueDays : "-",
      Submissions: row?.submission ? row?.submission : "-",
    }));

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });
      console.log(header , data , "data")

      const blobURL = window.URL.createObjectURL(blob);

      // Create new tag for download file
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
      anchor.click();

      // Remove URL.createObjectURL. The browser should not save the reference to the file.
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        URL.revokeObjectURL(blobURL);
      }, 1000);
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.map((col, index) => {
          obj[col] = row[col];
        });
        return obj;
      });

      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      });
      XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
      XLSX.writeFile(wb, `${fileName}.xlsx`);

      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data.map((row) => {
        return [row.Name, row["Status"], row["Type"], row["Assessment Code"], row["Intake"], row["Open Date"], row["Due Date"], row["Marking Status"], row["Marker"], row["Moderator"], row["Marking Due Date"], row["Marking Over Due Days"], row.Submissions];
      });
      const doc = new JsPDF('landscape');
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 20,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);

      return false;
    }
  };

  const resetFilter = () => {
    setSearch("");
    setStatus({ arr: [], checkObj: {} });
    setIntake({ arr: [], checkObj: {} });
    setType({ arr: [], checkObj: {} });
    setMarkingStatus({ arr: [], checkObj: {} });
    setAssessmentType({ arr: [], checkObj: {} });
  };

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const handleCreateAssessment = () => {
      if (Number(linkedProgrammes?.isLocked)) {
        handleGradesLocked(linkedProgrammes.data, "assessment");
      } else {
        history.push(`/courseAdministration/coursesdetails/${id}/${tab}/add`)
      }
  }

  const handleDuplicateAssessment = async (assessment_id) => {
    const result = await getLockedProgrammes([], assessment_id);
    if (result && result?.isLocked) {
      handleGradesLocked(result.data, "assessment");
    } else {
      history.push(`/courseAdministration/coursesdetails/${id}/${tab}/duplicate/assigned/Details/${assessment_id}`)
    }
  }

  const getLockedProgrammes = async (intake = [], assessment_id) => {
    try {
      setIsAssessmentBtnLoading(prev => ({
        ...prev,
        [assessment_id]: true
      }));

      let lockedProgrammeResult = null;
      if (intake.length) {
        const { data } = await lockedProgrammes({ intake_id: intake });
        lockedProgrammeResult = data;
      } else if (assessment_id) {
        const { data } = await lockedProgrammes({ assessment_id });
        lockedProgrammeResult = data;
      }
      return lockedProgrammeResult;

    } catch (error) {
      console.log("AssignedAssessments > getLockedProgrammes:", error);
      return null;
    } finally {
      setIsAssessmentBtnLoading(prev => ({
        ...prev,
        [assessment_id]: false
      }));
    }
  }


  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">

      <div className="l-o-c-t custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                  <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                    <div id="assessment-table-main_filter" className="dataTables_filter">
                      <label>
                        <input type="search" className="" placeholder="Search" aria-controls="assessment-table-main" onChange={handleSearchFilter} value={search} />
                      </label>
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="filter-scroll">
                  <div className={`filter-scroll-inner`}>
                    <Tablefilter
                      filterName={"Intake"}
                      optionArr={filterData.intake}
                      state={intake}
                      setState={setIntake}
                      isOptionReversed={true}
                    />
                    <Tablefilter
                      filterName={"Type"}
                      optionArr={filterData.type}
                      state={type}
                      setState={setType}
                      renderLabelFunction={RenderAssessmentType}
                    />
                    <Tablefilter
                      filterName={"Status"}
                      optionArr={filterData.status}
                      state={status}
                      setState={setStatus}
                      renderLabelFunction={RenderAssessmentStatus}
                    />
                    <Tablefilter
                      filterName={"Marking Status"}
                      optionArr={filterData.mStatus}
                      state={markingStatus}
                      setState={setMarkingStatus}
                      renderLabelFunction={RenderAssessmentStatus}
                    /> 
                     <Tablefilter
                      filterName={"Assessment Type"}
                      optionArr={filterData.assessmentType}
                      state={assessmentType}
                      setState={setAssessmentType}
                      stopOptionSorting={true}
                      renderLabelFunction={RenderQuizType}
                    />
                  </div>
                </div>
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button className="btn btn-primary" onClick={resetFilter} title="Reset">
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button type="button" className="btn btn-files" title="Export spreadsheet" onClick={() => {
                      exportData("xlsx", "Assigned-Assessment");
                    }}>
                      <i className="fal fa-file-excel icon"></i>
                    </button>
                    <button type="button" className="btn btn-files" title="Export CSV" onClick={() => {
                      exportData("csv", "Assigned-Assessment");
                    }}>
                      <i className="fal fa-file-csv icon"></i>
                    </button>
                    <button type="button" className="btn btn-files" title="Export PDF" onClick={() => {
                      exportData("pdf", "Assigned-Assessment");
                    }}>
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!quizId &&
          <div className="search-filter-div-right">
            <div className="filter-search-bar-blk">
              <div className="add-ticket-blk button-reset dropdown-comman">
                <PermissionsGate scopes={["castadd"]} errorProps={{ disabled: true }} >
                  <button className="btn btn-primary" onClick={() => handleCreateAssessment() } title="Create New" disabled={isGradeLocked} >
                    <i className="fal fa-plus"></i>Create New
                  </button>
                </PermissionsGate>
              </div>
            </div>
          </div>
          }
        </div>
        {!isListLoaded && <SkeletonTicketList />}
        {isListLoaded && <DataTable
          keyField="unique_id"
          data={dataToRender()}
          columns={columns}
          pagination={true}
          onChangeRowsPerPage={()=>{setUpdate(!update)}}
          defaultSortField="close_date_time_mili"
          defaultSortAsc={false}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />}

      </div>
    </div>
  );
};

export default AssignedAssessments;
